// extracted by mini-css-extract-plugin
export var copyright = "layoutApp-module--copyright--+X7eD";
export var flexCed = "layoutApp-module--flexCed--TfH1y";
export var logoWrapper = "layoutApp-module--logoWrapper--6hiqP";
export var titleWrapper = "layoutApp-module--titleWrapper--+d7Fq";
export var topPageWrapper = "layoutApp-module--topPageWrapper--suHah";
export var wrapper = "layoutApp-module--wrapper--ijWZA";